export const mapFields = {
    MAP_LATITUDE: 'map_latitude',
    MAP_LONGITUDE: 'map_longitude',
    MAP_LOCATION_SYNC: 'map_location_sync',
    MAP_LOCATION_SYNC_TYPE: 'map_location_sync_type',
}